import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';

type MutationInput = {
  clientId: string;
  reportId: string;
};

export function useDeleteSuitabilityReport() {
  const queryClient = useQueryClient();

  const { mutateAsync, error, isLoading, reset } = useMutation<unknown, Error, MutationInput>({
    mutationFn: ({ clientId, reportId }: MutationInput) =>
      api.delete(`clients/${clientId}/suitability-reports/${reportId}`),
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['clients'] });
    },
  });

  const deleteSuitabilityReport = async (clientId: string, reportId: string) => {
    return mutateAsync({ clientId, reportId });
  };

  return {
    deleteSuitabilityReport,
    error,
    isLoading,
    reset,
  };
}
